<script setup>

import { ref } from "vue";
import { decodeCredential, CallbackTypes, GoogleLogin } from 'vue3-google-login'
import { useUserStore } from '../store/user'
import { useWarehouseStore } from '../store/warehouse'
// import { GoogleAuth } from 'google-auth-library'
import router from "@/router";
import useAuthUser from "../components/UseAuthUser";
import { getAuth, signInWithEmailAndPassword ,sendPasswordResetEmail } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { loadScript } from "vue-plugin-load-script";
import { getWareHouseDNumbers } from '../components/Wrapper'
import { googleTokenLogin, googleSdkLoaded } from "vue3-google-login"
import Account from '../components/Account.vue'
import Auth from '../components/Auth.vue'
import useSupabase from '../lib/supabaseClient'
const { user } = useAuthUser();
const { supabase } = useSupabase();

const { loginWithEmail, loginWithSocialProvider } = useAuthUser();
// const CLIENT_ID = '101614418197803331552'
const CLIENT_ID = '60798862621-3cs7vh9jnl688o2erlc6jgr0d29u9int.apps.googleusercontent.com';
const API_KEY = 'AIzaSyCZeQ8YG4cXesXtU2QTnBV_Doj-fXqpsFU';
const SCOPES = 'email profile https://www.googleapis.com/auth/userinfo.profile openid https://www.googleapis.com/auth/userinfo.email ';
// Discovery doc URL for APIs used by the quickstart
const DISCOVERY_DOC = 'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest';

// Removed from scope and change to drive File https://www.googleapis.com/auth/spreadsheets.readonly
const firebaseConfig = {
  apiKey: "AIzaSyBFdWFWVc4G0kvTCYsWmRl7AkIu5I4Gy1g",
  authDomain: "multiservice-lookup.firebaseapp.com",
  projectId: "multiservice-lookup",
  storageBucket: "multiservice-lookup.firebasestorage.app",
  messagingSenderId: "783950432427",
  appId: "1:783950432427:web:36b32b5694e5f1d4d88fee",
  measurementId: "G-8W48TCVNHG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);


const login = () => {
    googleSdkLoaded((google) => {
        const oauth2 = google.accounts.oauth2.initTokenClient({
            client_id: CLIENT_ID,
            scope: SCOPES,
            hosted_domain: "europeanappliances.com", prompt: "select_account",
            callback: async (response) => {
                console.log("Handle the response", response)
                // gapiLoaded(response)

                // const tokenInfo = await oauth2.getTokenInfo(response.access_token);
                // console.log(tokenInfo);
                await loadScript("https://apis.google.com/js/api.js")
                gapiLoaded(response)
                //     .then(() => {
            }
        }).requestAccessToken()

    })


}

const session = ref()


supabase.auth.getSession().then(({ data }) => {
    session.value = data.session
    useUserStore().setUser(data.session.user)
    router.push('/')


})

supabase.auth.onAuthStateChange(async (_, _session) => {
    session.value = _session
    alert(JSON.stringify(_session))
    await loadScript("https://apis.google.com/js/api.js")
    gapiLoaded(_session.access_token)
    useUserStore().setUser(_session.user)
    router.push('/')
    // alert("AuthChange", _session);
})


let userData = ref();
const callback = (response) => {
    console.log("access_token", response);
    // login()
    userData.value = decodeCredential(response.credential)
    useUserStore().setUser(userData)
    router.push('/')
}
const idConfig = {
    hosted_domain: "europeanappliances.com"
}
async function gapiLoaded(token) {

    await gapi.load('client:auth2', initializeGapiClient(token))

}
const waitFor = (ms) => new Promise(r => setTimeout(r, ms));

/**
 * Callback after the API client is loaded. Loads the
 * discovery doc to initialize the API.
 */
async function initializeGapiClient(token) {

    try {
        await waitFor(100)
        console.log(gapi);
        gapi.client.setToken(token)
        gapi.client.load('https://www.googleapis.com/discovery/v1/apis/oauth2/v1/rest').then(async () => {
            userData.value = (await gapi.client.oauth2.userinfo.get()).result
            useUserStore().setUser(userData)
            router.push('/')

        })
        await waitFor(100)
        await listMajors()

    } catch (err) {
        console.error("error initing client", err);
    };


}

async function listMajors() {
    getWareHouseDNumbers().then(warehouseStock => {
        useWarehouseStore().setWarehouse(warehouseStock)
    })
}

const form = ref({
    email: "",
    password: "",
});
const handleLogin = (async () => {
    // alert("Login With Email",);
    try {

        await loginWithEmail(form.value);
        // router.push({ name: "Me" });

    } catch (error) {
        alert(error.message);
    }
})

const handleGoogleLogin = (async (provider) => {
    // alert("provider", provider);
    try {

        await loginWithSocialProvider(provider)


    } catch (error) {
        alert(error.message);
    }
})

const email = ref('');
    const password = ref('');
    const errorMessage = ref('');
const showPassword = ref(false)
const resetEmailSent = ref(false);

    const loginUser = async () => {
      try {
       const result= await signInWithEmailAndPassword(auth, email.value, password.value);
        
          useUserStore().setUser(result.user)
          router.push('/')
      } catch (error) {
        errorMessage.value = error.message;
      }
    };
    const forgotPassword = async () => {
        if (!email.value) {
    errorMessage.value = "Please enter your email address.";
    resetEmailSent.value = false; // Ensure reset confirmation is not shown
    return;
  }

  try {
    await sendPasswordResetEmail(auth, email.value);
    resetEmailSent.value = true; // Show confirmation
    errorMessage.value = ''; // Clear any previous errors
  } catch (error) {
    errorMessage.value = error.message; // Display error if any
    resetEmailSent.value = false; // Ensure confirmation is not shown
  }

};

</script>

<template>
  <body>
    <main class="main-content">
        <h1 class="login-title">Please Login to Your Beko Account</h1>
        
        <button  @click="login" class="google-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="white">
                <path d="M12.545 10.239v3.821h5.445c-.712 2.315-2.647 3.972-5.445 3.972a6.033 6.033 0 1 1 0-12.064c1.498 0 2.866.549 3.921 1.453l2.814-2.814A9.969 9.969 0 0 0 12.545 2C7.021 2 2.543 6.477 2.543 12s4.478 10 10.002 10c8.396 0 10.249-7.85 9.426-11.748l-9.426-.013z"></path>
            </svg>
            Login Using Google
        </button>
        
        <div class="form-divider">OR</div>
        
        <form @submit.prevent="loginUser">
            <div class="form-group">
                <label for="email" class="form-label">Email</label>
                <input v-model="email" type="email" id="email" class="form-input" autocomplete="on" required>
            </div>
            
            <div class="form-group">
            <label for="password" class="form-label">Password</label>
             <div style="position: relative;">
       <input 
      :type="showPassword ? 'text' : 'password'" 
      id="password" 
      v-model="password" 
      class="form-input" 
      autocomplete="on"
      required
    >
    <button 
      type="button" 
      @click="showPassword = !showPassword" 
      style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer;"
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="20" 
        height="20" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round"
      >
        <path v-if="showPassword" d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
        <line v-if="showPassword" x1="1" y1="1" x2="23" y2="23"></line>
        
        <path v-if="!showPassword" d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
        <circle v-if="!showPassword" cx="12" cy="12" r="3"></circle>
      </svg>
    </button>
  </div>
</div>
            
            <button type="submit" class="login-button">Login</button>
        </form>
       
        <!-- Forgot Password Link -->
        <a href="#" class="forgot-password" @click="forgotPassword">Forgot Password?</a>

        <!-- Error Message Display -->
        <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
        
        <!-- Reset Confirmation Message -->
        <div v-if="resetEmailSent" class="success-message">A password reset email has been sent to your email address.</div>
        <!-- <a href="#" class="forgot-password">Forgot Password?</a> -->
    </main>
</body>
</template>
<style>
:root {
    --beko-navy: #0a1f44;
    --beko-blue: #1e52a4;
    --beko-light-gray: #f5f7fa;
    --shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

body {
    background-color: var(--beko-light-gray);
}

.header {
    background-color: var(--beko-navy);
    color: white;
    padding: 15px 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: var(--shadow);
}

.brand {
    display: flex;
    align-items: center;
    gap: 10px;
}

.brand img {
    height: 32px;
}

.brand-name {
    font-size: 22px;
    font-weight: 600;
}

.header-icons {
    display: flex;
    align-items: center;
    gap: 20px;
}

.icon-button {
    background: none;
    border: none;
    color: white;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    font-size: 16px;
}

.main-content {
    max-width: 500px;
    margin: 60px auto;
    background-color: white;
    border-radius: 10px;
    box-shadow: var(--shadow);
    padding: 30px;
}

.login-title {
    text-align: center;
    margin-bottom: 30px;
    color: var(--beko-navy);
    font-size: 24px;
    font-weight: 600;
}

.google-button {
    display: block;
    width: 100%;
    padding: 12px;
    background-color: #ea4335;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 25px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
}

.google-button:hover {
    background-color: #d33426;
    transform: translateY(-2px);
}

.form-divider {
    display: flex;
    align-items: center;
    margin: 20px 0;
    color: #666;
}

.form-divider::before,
.form-divider::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #ddd;
}

.form-divider::before {
    margin-right: 10px;
}

.form-divider::after {
    margin-left: 10px;
}

.form-group {
    margin-bottom: 20px;
}

.form-label {
    display: block;
    margin-bottom: 8px;
    color: #555;
    font-weight: 500;
}

.form-input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 16px;
    transition: all 0.2s ease;
}

.form-input:focus {
    outline: none;
    border-color: var(--beko-blue);
    box-shadow: 0 0 0 3px rgba(30, 82, 164, 0.2);
}

.login-button {
    display: block;
    width: 100%;
    padding: 12px;
    background-color: var(--beko-blue);
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.login-button:hover {
    background-color: #164085;
    transform: translateY(-2px);
}

.error-message {
    margin-top: 10px;
    color: red;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
}

.success-message {
    margin-top: 10px;
    color: green;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
}

.forgot-password {
    display: block;
    text-align: center;
    margin-top: 20px;
    color: var(--beko-blue);
    text-decoration: none;
}

.forgot-password:hover {
    text-decoration: underline;
}
</style>